import React from "react";
import { Link } from "react-router-dom";
import * as DateHelper from "../utils/date.formatter";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

export default props => {
  if (!props.data || props.data.length === 0) {
    return <div className="empty-data">{i18n.t("system.empty_data")}</div>;
  }
  return (
    <ul className="box-list">
      {props.data.map(item => {
        return (
          <li key={item.key}>
            <Link to={`/sites/${item.key}`}>
              <strong>{item.name}</strong>
              <span>{item.key}</span>
              <em>{DateHelper.toLocalDateString(item.created)}</em>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
